import { Select } from 'antd';
import styles from './dropdown.module.scss';
import Icon from '@ant-design/icons/lib/components/Icon';
import ChevronDown from '@/assets/icons/chevron-down.svg?react';
import ChevronUp from '@/assets/icons/chevron-up.svg?react';
import { SelectProps } from 'antd/es/select';
import { ReactNode, useState } from 'react';
import { FieldStatus } from '../form.types';
import clsx from 'clsx';
import { useScreenSize } from '@/hooks/use-screen-size/use-screen-size';

interface DropdownProps extends Omit<SelectProps, 'status'> {
  status?: FieldStatus;
  prefixIcon?: ReactNode;
  dropdownListClass?: string;
  wrapperClassName?: string;
  allowClear?: boolean;
}

export default function Dropdown({
  options,
  status,
  disabled,
  open,
  prefixIcon,
  dropdownListClass,
  wrapperClassName,
  allowClear = true,
  ...restProps
}: DropdownProps) {
  const [isOpen, setIsOpen] = useState(open);
  const screenSize = useScreenSize();
  const isMobile = screenSize.width < 768;

  return (
    <div className={clsx(wrapperClassName, styles.dropdownWrapper)}>
      {prefixIcon && <span className={styles.dropdownPrefixIcon}>{prefixIcon}</span>}
      <Select
        {...restProps}
        allowClear={allowClear}
        open={isOpen}
        onOpenChange={(change) => setIsOpen(change)}
        disabled={disabled}
        classNames={{
          popup: {
            root: clsx(styles.dropdownList, dropdownListClass && dropdownListClass),
          },
        }}
        rootClassName={clsx(
          styles.dropdown,
          disabled && styles['dropdown-disabled'],
          isOpen && styles.dropdownOpen,
          status && styles[`dropdown-${status}`],
          prefixIcon && styles.dropdownPaddingLeft
        )}
        options={options}
        variant="borderless"
        tabIndex={0}
        suffixIcon={
          isMobile ? undefined : (
            <Icon
              onClick={() => setIsOpen((prev) => !prev)}
              style={{ cursor: 'unset' }}
              className={clsx(styles.chevronIcon, disabled && styles.chevronIconDisabled)}
              component={() => (isOpen ? <ChevronUp /> : <ChevronDown />)}
            />
          )
        }
      />
    </div>
  );
}
